import React from 'react';
import './ServiceCard.css';

interface ServiceCardProps {
  title: string;
  features: string[];
}

const ServiceCard: React.FC<ServiceCardProps> = ({ title, features }) => {
  return (
    <div className="service-solution-card">
      <h3 className="service-solution-title">{title}</h3>
      <ul className="service-solution-features">
        {features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceCard;
